webpackJsonp([83,81],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(4);


/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.router = undefined;
	
	__webpack_require__(379);
	
	__webpack_require__(378);
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(606);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueMoment = __webpack_require__(605);
	
	var _vueMoment2 = _interopRequireDefault(_vueMoment);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	__webpack_require__(233);
	
	var _routes = __webpack_require__(234);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _App = __webpack_require__(26);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _PageContent = __webpack_require__(416);
	
	var _PageContent2 = _interopRequireDefault(_PageContent);
	
	var _DocsComponent = __webpack_require__(414);
	
	var _DocsComponent2 = _interopRequireDefault(_DocsComponent);
	
	var _ExampleBox = __webpack_require__(415);
	
	var _ExampleBox2 = _interopRequireDefault(_ExampleBox);
	
	var _ApiTable = __webpack_require__(412);
	
	var _ApiTable2 = _interopRequireDefault(_ApiTable);
	
	var _CodeBlock = __webpack_require__(413);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('page-content', _PageContent2.default);
	_vue2.default.component('docs-component', _DocsComponent2.default);
	_vue2.default.component('example-box', _ExampleBox2.default);
	_vue2.default.component('api-table', _ApiTable2.default);
	_vue2.default.component('code-block', _CodeBlock2.default);
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueMoment2.default);
	
	_axios2.default.defaults.baseURL = 'http://premier.intelligence.id/v1';
	
	_axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');
	
	exports.default = _vue2.default;
	var router = exports.router = new _vueRouter2.default({
	  mode: 'hash',
	  base: window.location.pathname,
	  routes: _routes2.default
	});
	
	var Docs = _vue2.default.component('app', _App2.default);
	var handleSectionTheme = function handleSectionTheme(currentRoute) {
	
	  var theme = 'default';
	
	  var name = currentRoute.name;
	
	  if (name) {
	    if (name === 'administrative:entry') {
	      theme = 'blue';
	    } else if (name === 'administrative:request' || name === 'keyguard:request') {
	      theme = 'teal';
	    } else if (name === 'administrative:status' || name === 'keyguard:status' || name === 'administrative:status_checkin') {
	      theme = 'brown';
	    } else if (name === 'administrative:history' || name === 'keyguard:history' || name === 'administrative:status_checkout') {
	      theme = 'indigo';
	    } else if (name === 'administrative:reports' || name === 'keyguard:reports' || name === 'administrative:status_all') {
	      theme = 'purple';
	    } else if (name === 'preference:profile') {
	      theme = 'orange';
	    } else if (name === 'preference:password') {
	      theme = 'green';
	    } else if (name === 'maps') {
	      theme = 'blue-grey';
	    } else if (name === 'error') {
	      theme = 'red';
	    }
	  }
	
	  _vue2.default.material.setCurrentTheme(theme);
	};
	
	Docs = new Docs({
	  el: '#app',
	  router: router
	});
	
	handleSectionTheme(router.currentRoute);
	
	router.beforeEach(function (to, from, next) {
	  _vue2.default.nextTick(function () {
	    var mainContent = document.querySelector('.main-content');
	
	    if (mainContent) {
	      mainContent.scrollTop = 0;
	    }
	
	    Docs.closeSidenav();
	
	    next();
	  });
	});
	
	router.afterEach(function (to) {
	  if (localStorage.getItem('id_token') === null) {
	    router.push({
	      name: 'signin'
	    });
	  }
	  handleSectionTheme(to);
	});

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(387)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(235),
	  /* template */
	  __webpack_require__(549),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(62);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _axios = __webpack_require__(3);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _main = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  user: {
	    authenticated: false,
	    profile: null,
	    hasRole_carowner: false,
	    hasRole_administrative: false,
	    hasRole_runner: false,
	    hasRole_keyguard: false,
	    hasRole_assup: false,
	    hasRole_supervisor: false,
	    hasRole_operasional: false,
	    hasRole_keuangan: false,
	    hasRole_adminsite: false,
	    hasRole_mod: false,
	    hasRole_adminsystem: false
	  }, signout: function signout() {
	    var _this = this;
	
	    _axios2.default.get('/signout').then(function () {
	      localStorage.removeItem('id_token');
	      _this.user.authenticated = false;
	      _this.user.profile = null;
	
	      _main.router.push({
	        name: 'signin'
	      });
	    }, function (error) {
	      console.log(error);
	    });
	  },
	  signin: function signin(context, email, password) {
	    var _this2 = this;
	
	    _axios2.default.post('authenticate', {
	      email: email,
	      password: password
	    }).then(function (response) {
	
	      context.error = false;
	      localStorage.setItem('id_token', response.data.meta.token);
	      _axios2.default.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('id_token');
	
	      _this2.user.authenticated = true;
	      _this2.user.profile = response.data.data;
	
	      _this2.user.hasRole_carowner = false;
	      _this2.user.hasRole_administrative = false;
	      _this2.user.hasRole_runner = false;
	      _this2.user.hasRole_keyguard = false;
	      _this2.user.hasRole_assup = false;
	      _this2.user.hasRole_supervisor = false;
	      _this2.user.hasRole_operasional = false;
	      _this2.user.hasRole_keuangan = false;
	      _this2.user.hasRole_adminsite = false;
	      _this2.user.hasRole_mod = false;
	      _this2.user.hasRole_adminsystem = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(response.data.data.has_role), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var has_role = _step.value;
	
	          switch (has_role.rlms_id) {
	            case 99:
	              _this2.user.hasRole_adminsystem = true;
	              break;
	            case 90:
	              _this2.user.hasRole_mod = true;
	              break;
	            case 80:
	              _this2.user.hasRole_adminsite = true;
	              break;
	            case 70:
	              _this2.user.hasRole_keuangan = true;
	              break;
	            case 60:
	              _this2.user.hasRole_operasional = true;
	              break;
	            case 55:
	              _this2.user.hasRole_supervisor = true;
	              break;
	            case 50:
	              _this2.user.hasRole_assup = true;
	              break;
	            case 40:
	              _this2.user.hasRole_keyguard = true;
	              break;
	            case 30:
	              _this2.user.hasRole_runner = true;
	              break;
	            case 20:
	              _this2.user.hasRole_administrative = true;
	              break;
	            case 10:
	              _this2.user.hasRole_carowner = true;
	              break;
	            default:
	              _this2.user.hasRole_carowner = false;
	              _this2.user.hasRole_administrative = false;
	              _this2.user.hasRole_runner = false;
	              _this2.user.hasRole_keyguard = false;
	              _this2.user.hasRole_assup = false;
	              _this2.user.hasRole_supervisor = false;
	              _this2.user.hasRole_operasional = false;
	              _this2.user.hasRole_keuangan = false;
	              _this2.user.hasRole_adminsite = false;
	              _this2.user.hasRole_mod = false;
	              _this2.user.hasRole_adminsystem = false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      _main.router.push({
	        name: 'maps'
	      });
	    }, function (error) {
	      context.error = true;
	      console.log(error);
	    });
	  }
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(393)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(322),
	  /* template */
	  __webpack_require__(579),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueMaterial = __webpack_require__(604);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	__webpack_require__(396);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueMaterial2.default);
	
	_vue2.default.material.registerTheme({
	  default: {
	    primary: 'blue',
	    accent: 'pink'
	  },
	  blue: {
	    primary: 'blue',
	    accent: 'pink'
	  },
	  indigo: {
	    primary: 'indigo',
	    accent: 'pink'
	  },
	  brown: {
	    primary: 'brown',
	    accent: 'green'
	  },
	  purple: {
	    primary: 'purple',
	    accent: 'blue'
	  },
	  orange: {
	    primary: 'orange',
	    accent: 'purple'
	  },
	  green: {
	    primary: 'green',
	    accent: 'pink'
	  },
	  'light-blue': {
	    primary: 'light-blue',
	    accent: 'yellow'
	  },
	  teal: {
	    primary: 'teal',
	    accent: 'orange'
	  },
	  'blue-grey': {
	    primary: 'blue-grey',
	    accent: 'blue'
	  },
	  cyan: {
	    primary: 'cyan',
	    accent: 'pink'
	  },
	  red: {
	    primary: 'red',
	    accent: 'pink'
	  },
	  white: {
	    primary: 'white',
	    accent: 'blue'
	  },
	  grey: {
	    primary: {
	      color: 'grey',
	      hue: 300
	    },
	    accent: 'indigo'
	  }
	});

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Signin = __webpack_require__(421);
	var Dashboard = __webpack_require__(417);
	var Landing = __webpack_require__(419);
	var Maps = __webpack_require__(420);
	
	var Error404 = __webpack_require__(418);
	
	var PreferenceProfile = function PreferenceProfile(resolve) {
	  return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(495)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var PreferencePassword = function PreferencePassword(resolve) {
	  return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(494)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var PreferenceSite = function PreferenceSite(resolve) {
	  return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(496)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var adsys_masters_company = function adsys_masters_company(resolve) {
	  return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(458)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_car = function adsys_masters_car(resolve) {
	  return __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(455)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_color = function adsys_masters_color(resolve) {
	  return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(457)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_cardefect = function adsys_masters_cardefect(resolve) {
	  return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(456)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_monitor = function adsys_masters_monitor(resolve) {
	  return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(461)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_status = function adsys_masters_status(resolve) {
	  return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(465)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_role = function adsys_masters_role(resolve) {
	  return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(464)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_postal = function adsys_masters_postal(resolve) {
	  return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(463)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_payment_categories = function adsys_masters_payment_categories(resolve) {
	  return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(462)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_menu = function adsys_masters_menu(resolve) {
	  return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(460)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_masters_defect = function adsys_masters_defect(resolve) {
	  return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(459)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var adsys_config_site = function adsys_config_site(resolve) {
	  return __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(452)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_caritemmaster = function adsys_config_caritemmaster(resolve) {
	  return __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(436)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_caritem = function adsys_config_caritem(resolve) {
	  return __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(435)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_assets = function adsys_config_assets(resolve) {
	  return __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(432)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_carcompany = function adsys_config_carcompany(resolve) {
	  return __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(433)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_carfile = function adsys_config_carfile(resolve) {
	  return __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(434)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_employee = function adsys_config_employee(resolve) {
	  return __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(438)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_finefee = function adsys_config_finefee(resolve) {
	  return __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(439)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_floors = function adsys_config_floors(resolve) {
	  return __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(440)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_imei = function adsys_config_imei(resolve) {
	  return __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(441)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_workshift = function adsys_config_workshift(resolve) {
	  return __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_valetfee = function adsys_config_valetfee(resolve) {
	  return __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(453)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_park_area = function adsys_config_park_area(resolve) {
	  return __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(446)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_park_sector = function adsys_config_park_sector(resolve) {
	  return __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(448)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_park_detail = function adsys_config_park_detail(resolve) {
	  return __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(447)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_keyguard = function adsys_config_keyguard(resolve) {
	  return __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(443)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_keyguard_details = function adsys_config_keyguard_details(resolve) {
	  return __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(444)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_keyguard_position = function adsys_config_keyguard_position(resolve) {
	  return __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(445)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_imei_detail = function adsys_config_imei_detail(resolve) {
	  return __webpack_require__.e/* require */(58, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(442)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_droppoint_floor = function adsys_config_droppoint_floor(resolve) {
	  return __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(437)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_print = function adsys_config_print(resolve) {
	  return __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(450)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_report_administrative = function adsys_config_report_administrative(resolve) {
	  return __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(451)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var adsys_config_payment_methods = function adsys_config_payment_methods(resolve) {
	  return __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(449)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var AdministrativeEntry = function AdministrativeEntry(resolve) {
	  return __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(422)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeRequest = function AdministrativeRequest(resolve) {
	  return __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(427)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeStatusFind = function AdministrativeStatusFind(resolve) {
	  return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(431)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeStatusCheckIn = function AdministrativeStatusCheckIn(resolve) {
	  return __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(429)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeStatusCheckOut = function AdministrativeStatusCheckOut(resolve) {
	  return __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(430)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeStatusAll = function AdministrativeStatusAll(resolve) {
	  return __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(428)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeHistory = function AdministrativeHistory(resolve) {
	  return __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(423)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeReportsMain = function AdministrativeReportsMain(resolve) {
	  return __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(425)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeReportsDetail = function AdministrativeReportsDetail(resolve) {
	  return __webpack_require__.e/* require */(80, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(424)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var AdministrativeReportsUnclosed = function AdministrativeReportsUnclosed(resolve) {
	  return __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(426)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var KeyguardRequest = function KeyguardRequest(resolve) {
	  return __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(487)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var KeyguardStatus = function KeyguardStatus(resolve) {
	  return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(488)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var KeyguardHistory = function KeyguardHistory(resolve) {
	  return __webpack_require__.e/* require */(79, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(485)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var KeyguardReports = function KeyguardReports(resolve) {
	  return __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(486)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Employee = function Employee(resolve) {
	  return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(492)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Flow = function Flow(resolve) {
	  return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(493)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Color = function Color(resolve) {
	  return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(490)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Company = function Company(resolve) {
	  return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(491)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Site = function Site(resolve) {
	  return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(481)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Floor = function Floor(resolve) {
	  return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(479)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Droppoint = function Droppoint(resolve) {
	  return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(478)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var PrintTemplate = function PrintTemplate(resolve) {
	  return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(480)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Disclaimer = function Disclaimer(resolve) {
	  return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(477)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Price = function Price(resolve) {
	  return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(476)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var FineFee = function FineFee(resolve) {
	  return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(474)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var ParkFee = function ParkFee(resolve) {
	  return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(475)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Keyguard = function Keyguard(resolve) {
	  return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(470)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var DeskList = function DeskList(resolve) {
	  return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(468)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var DeskPositionList = function DeskPositionList(resolve) {
	  return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(469)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Park = function Park(resolve) {
	  return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(471)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var ParkSector = function ParkSector(resolve) {
	  return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(473)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var ParkAreaDetail = function ParkAreaDetail(resolve) {
	  return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(472)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var CarFile = function CarFile(resolve) {
	  return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(467)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var CarDefect = function CarDefect(resolve) {
	  return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(466)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var DailyHeaders = function DailyHeaders(resolve) {
	  return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(498)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var DailyDetails = function DailyDetails(resolve) {
	  return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(497)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var FinefeeDetails = function FinefeeDetails(resolve) {
	  return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(500)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var ParkfeeDetails = function ParkfeeDetails(resolve) {
	  return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(502)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var ItemDetails = function ItemDetails(resolve) {
	  return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(501)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var DefectDetails = function DefectDetails(resolve) {
	  return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(499)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var SiteTransaction = function SiteTransaction(resolve) {
	  return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(489)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var Menu = function Menu(resolve) {
	  return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(482)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var PostalCode = function PostalCode(resolve) {
	  return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(483)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Role = function Role(resolve) {
	  return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(484)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	var main = [{
	  path: '/',
	  name: 'signin',
	  component: Signin
	}, {
	  path: '/dashboard',
	  name: 'dashboard',
	  component: Dashboard
	}, {
	  path: '/landing',
	  name: 'landing',
	  component: Landing
	}, {
	  path: '/maps',
	  name: 'maps',
	  component: Maps
	}];
	
	var adsys = [{
	  path: '/adsys',
	  name: 'adsys',
	  redirect: '/adsys/masters/company'
	}, {
	  path: '/adsys/masters',
	  name: 'adsys:masters',
	  redirect: '/adsys/masters/company'
	}, {
	  path: '/adsys/masters/company',
	  name: 'adsys:masters:company',
	  component: adsys_masters_company
	}, {
	  path: '/adsys/masters/car',
	  name: 'adsys:masters:car',
	  component: adsys_masters_car
	}, {
	  path: '/adsys/masters/color',
	  name: 'adsys:masters:color',
	  component: adsys_masters_color
	}, {
	  path: '/adsys/masters/cardefect',
	  name: 'adsys:masters:cardefect',
	  component: adsys_masters_cardefect
	}, {
	  path: '/adsys/masters/monitor',
	  name: 'adsys:masters:monitor',
	  component: adsys_masters_monitor
	}, {
	  path: '/adsys/masters/status',
	  name: 'adsys:masters:status',
	  component: adsys_masters_status
	}, {
	  path: '/adsys/masters/role',
	  name: 'adsys:masters:role',
	  component: adsys_masters_role
	}, {
	  path: '/adsys/masters/postal',
	  name: 'adsys:masters:postal',
	  component: adsys_masters_postal
	}, {
	  path: '/adsys/masters/payment_categories',
	  name: 'adsys:masters:payment_categories',
	  component: adsys_masters_payment_categories
	}, {
	  path: '/adsys/masters/menu',
	  name: 'adsys:masters:menu',
	  component: adsys_masters_menu
	}, {
	  path: '/adsys/masters/defect_master',
	  name: 'adsys:masters:defect_master',
	  component: adsys_masters_defect
	}, {
	  path: '/adsys/config',
	  name: 'adsys:config',
	  redirect: '/adsys/config/site'
	}, {
	  path: '/adsys/config/site',
	  name: 'adsys:config:site',
	  component: adsys_config_site
	}, {
	  path: '/adsys/config/caritemmaster',
	  name: 'adsys:config:caritemmaster',
	  component: adsys_config_caritemmaster
	}, {
	  path: '/adsys/config/caritem',
	  name: 'adsys:config:caritem',
	  component: adsys_config_caritem
	}, {
	  path: '/adsys/config/assets',
	  name: 'adsys:config:assets',
	  component: adsys_config_assets
	}, {
	  path: '/adsys/config/carcompany',
	  name: 'adsys:config:carcompany',
	  component: adsys_config_carcompany
	}, {
	  path: '/adsys/config/carfile',
	  name: 'adsys:config:carfile',
	  component: adsys_config_carfile
	}, {
	  path: '/adsys/config/employee',
	  name: 'adsys:config:employee',
	  component: adsys_config_employee
	}, {
	  path: '/adsys/config/finefee',
	  name: 'adsys:config:finefee',
	  component: adsys_config_finefee
	}, {
	  path: '/adsys/config/floor',
	  name: 'adsys:config:floor',
	  component: adsys_config_floors
	}, {
	  path: '/adsys/config/imei',
	  name: 'adsys:config:imei',
	  component: adsys_config_imei
	}, {
	  path: '/adsys/config/workshift',
	  name: 'adsys:config:workshift',
	  component: adsys_config_workshift
	}, {
	  path: '/adsys/config/valetfee',
	  name: 'adsys:config:valetfee',
	  component: adsys_config_valetfee
	}, {
	  path: '/adsys/config/park_area',
	  name: 'adsys:config:park_area',
	  component: adsys_config_park_area
	}, {
	  path: '/adsys/config/park_sector',
	  name: 'adsys:config:park_sector',
	  component: adsys_config_park_sector
	}, {
	  path: '/adsys/config/park_detail',
	  name: 'adsys:config:park_detail',
	  component: adsys_config_park_detail
	}, {
	  path: '/adsys/config/keyguard',
	  name: 'adsys:config:keyguard',
	  component: adsys_config_keyguard
	}, {
	  path: '/adsys/config/keyguard_details',
	  name: 'adsys:config:keyguard_details',
	  component: adsys_config_keyguard_details
	}, {
	  path: '/adsys/config/keyguard_position',
	  name: 'adsys:config:keyguard_position',
	  component: adsys_config_keyguard_position
	}, {
	  path: '/adsys/config/imei_detail',
	  name: 'adsys:config:imei_detail',
	  component: adsys_config_imei_detail
	}, {
	  path: '/adsys/config/droppoint_floor',
	  name: 'adsys:config:droppoint_floor',
	  component: adsys_config_droppoint_floor
	}, {
	  path: '/adsys/config/print',
	  name: 'adsys:config:print',
	  component: adsys_config_print
	}, {
	  path: '/adsys/config/report_administrative',
	  name: 'adsys:config:report_administrative',
	  component: adsys_config_report_administrative
	}, {
	  path: '/adsys/config/payment_methods',
	  name: 'adsys:config:payment_methods',
	  component: adsys_config_payment_methods
	}];
	
	var administrative = [{
	  path: '/administrative',
	  name: 'administrative',
	  redirect: '/administrative/entry'
	}, {
	  path: '/administrative/entry',
	  name: 'administrative:entry',
	  component: AdministrativeEntry
	}, {
	  path: '/administrative/request',
	  name: 'administrative:request',
	  component: AdministrativeRequest
	}, {
	  path: '/administrative/status_checkin',
	  name: 'administrative:status_checkin',
	  component: AdministrativeStatusCheckIn
	}, {
	  path: '/administrative/status_find',
	  name: 'administrative:status_find',
	  component: AdministrativeStatusFind
	}, {
	  path: '/administrative/status_checkout',
	  name: 'administrative:status_checkout',
	  component: AdministrativeStatusCheckOut
	}, {
	  path: '/administrative/status_all',
	  name: 'administrative:status_all',
	  component: AdministrativeStatusAll
	}, {
	  path: '/administrative/history',
	  name: 'administrative:history',
	  component: AdministrativeHistory
	}, {
	  path: '/administrative/reports_detail',
	  name: 'administrative:reports_detail',
	  component: AdministrativeReportsDetail
	}, {
	  path: '/administrative/reports_main',
	  name: 'administrative:reports_main',
	  component: AdministrativeReportsMain
	}, {
	  path: '/administrative/reports_unclosed',
	  name: 'administrative:reports_unclosed',
	  component: AdministrativeReportsUnclosed
	}];
	
	var keyguard = [{
	  path: '/keyguard',
	  name: 'keyguard',
	  redirect: '/keyguard/request'
	}, {
	  path: '/keyguard/request',
	  name: 'keyguard:request',
	  component: KeyguardRequest
	}, {
	  path: '/keyguard/status',
	  name: 'keyguard:status',
	  component: KeyguardStatus
	}, {
	  path: '/keyguard/history',
	  name: 'keyguard:history',
	  component: KeyguardHistory
	}, {
	  path: '/keyguard/reports',
	  name: 'keyguard:reports',
	  component: KeyguardReports
	}];
	
	var preference = [{
	  path: '/preference',
	  name: 'preference',
	  redirect: '/preference/profile'
	}, {
	  path: '/preference/profile',
	  name: 'preference:profile',
	  component: PreferenceProfile
	}, {
	  path: '/preference/password',
	  name: 'preference:password',
	  component: PreferencePassword
	}, {
	  path: '/preference/site',
	  name: 'preference:site',
	  component: PreferenceSite
	}];
	
	var masters = [{
	  path: '/masters',
	  name: 'masters',
	  redirect: '/masters/employee'
	}, {
	  path: '/masters/employee',
	  name: 'masters:employee',
	  component: Employee
	}, {
	  path: '/masters/flow',
	  name: 'masters:flow',
	  component: Flow
	}, {
	  path: '/masters/color',
	  name: 'masters:color',
	  component: Color
	}, {
	  path: '/masters/company',
	  name: 'masters:company',
	  component: Company
	}];
	
	var configuration = [{
	  path: '/configuration',
	  name: 'configuration',
	  redirect: '/configuration/site/site'
	}, {
	  path: '/configuration/site',
	  name: 'configuration:site',
	  redirect: '/configuration/site/site'
	}, {
	  path: '/configuration/site/site',
	  name: 'configuration:site:site',
	  component: Site
	}, {
	  path: '/configuration/site/floor',
	  name: 'configuration:site:floor',
	  component: Floor
	}, {
	  path: '/configuration/site/droppoint',
	  name: 'configuration:site:droppoint',
	  component: Droppoint
	}, {
	  path: '/configuration/site/printtemplate',
	  name: 'configuration:site:printtemplate',
	  component: PrintTemplate
	}, {
	  path: '/configuration/site/disclaimer',
	  name: 'configuration:site:disclaimer',
	  component: Disclaimer
	}, {
	  path: '/configuration/price/price',
	  name: 'configuration:price:price',
	  component: Price
	}, {
	  path: '/configuration/price/finefee',
	  name: 'configuration:price:finefee',
	  component: FineFee
	}, {
	  path: '/configuration/price/parkfee',
	  name: 'configuration:price:parkfee',
	  component: ParkFee
	}, {
	  path: '/configuration/keyguard/keyguard',
	  name: 'configuration:keyguard:keyguard',
	  component: Keyguard
	}, {
	  path: '/configuration/keyguard/desklist',
	  name: 'configuration:keyguard:desklist',
	  component: DeskList
	}, {
	  path: '/configuration/keyguard/deskpositionlist',
	  name: 'configuration:keyguard:deskpositionlist',
	  component: DeskPositionList
	}, {
	  path: '/configuration/park/park',
	  name: 'configuration:park:park',
	  component: Park
	}, {
	  path: '/configuration/park/parksector',
	  name: 'configuration:park:parksector',
	  component: ParkSector
	}, {
	  path: '/configuration/park/parkareadetail',
	  name: 'configuration:park:parkareadetail',
	  component: ParkAreaDetail
	}, {
	  path: '/configuration/car/carfile',
	  name: 'configuration:car:carfile',
	  component: CarFile
	}, {
	  path: '/configuration/car/cardefect',
	  name: 'configuration:car:cardefect',
	  component: CarDefect
	}];
	
	var reports = [{
	  path: '/reports',
	  name: 'reports',
	  redirect: '/reports/DailyHeaders'
	}, {
	  path: '/reports/dailyheaders',
	  name: 'reports:dailyheaders',
	  component: DailyHeaders
	}, {
	  path: '/reports/dailydetails',
	  name: 'reports:dailydetails',
	  component: DailyDetails
	}, {
	  path: '/reports/finefeedetails',
	  name: 'reports:finefeedetails',
	  component: FinefeeDetails
	}, {
	  path: '/reports/parkfeedetails',
	  name: 'reports:parkfeedetails',
	  component: ParkfeeDetails
	}, {
	  path: '/reports/itemdetails',
	  name: 'reports:itemdetails',
	  component: ItemDetails
	}, {
	  path: '/reports/defectdetails',
	  name: 'reports:defectdetails',
	  component: DefectDetails
	}];
	
	var logs = [{
	  path: '/logs',
	  name: 'logs',
	  redirect: '/logs/sitetransaction'
	}, {
	  path: '/logs/sitetransaction',
	  name: 'logs:sitetransaction',
	  component: SiteTransaction
	}];
	
	var etc = [{
	  path: '/etc',
	  name: 'etc',
	  redirect: '/etc/menu'
	}, {
	  path: '/etc/menu',
	  name: 'etc:menu',
	  component: Menu
	}, {
	  path: '/etc/postalcode',
	  name: 'etc:postalcode',
	  component: PostalCode
	}, {
	  path: '/etc/role',
	  name: 'etc:role',
	  component: Role
	}];
	
	var error = [{
	  path: '*',
	  name: 'error',
	  component: Error404
	}];
	
	exports.default = [].concat(main, adsys, administrative, keyguard, preference, masters, configuration, reports, logs, etc, error);

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(41);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _main = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['pageTitle'],
	  data: function data() {
	    return {
	      toolbar: true,
	      theme: 'default',
	      auth: _auth2.default,
	      tempTitle: null
	    };
	  },
	
	  computed: {
	    logo: function logo() {
	
	      return __webpack_require__(408);
	    }
	  },
	  watch: {
	    tempTitle: function tempTitle() {
	      this.pageTitle = this.tempTitle;
	    }
	  },
	  methods: {
	    redirect: function redirect(url, title) {
	      this.tempTitle = title;
	      _main.router.push({
	        name: url
	      });
	    },
	    toggleSidenav: function toggleSidenav() {
	      this.$refs['main-sidebar'].toggle();
	    },
	    closeSidenav: function closeSidenav() {
	      this.$refs['main-sidebar'].close();
	    },
	    signout: function signout() {
	      _auth2.default.signout();
	    }
	  },
	  mounted: function mounted() {
	    if (_auth2.default.user.profile === null) {
	      _main.router.push({
	        name: 'signin'
	      });
	    }
	    this.tempTitle = 'Map';
	  }
	};

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(63);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    name: String
	  },
	  computed: {
	    slotNames: function slotNames() {
	      return (0, _keys2.default)(this.$slots);
	    }
	  }
	};

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _highlight = __webpack_require__(399);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _scss = __webpack_require__(402);
	
	var _scss2 = _interopRequireDefault(_scss);
	
	var _xml = __webpack_require__(403);
	
	var _xml2 = _interopRequireDefault(_xml);
	
	var _javascript = __webpack_require__(401);
	
	var _javascript2 = _interopRequireDefault(_javascript);
	
	var _bash = __webpack_require__(400);
	
	var _bash2 = _interopRequireDefault(_bash);
	
	var _clipboard = __webpack_require__(331);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_highlight2.default.registerLanguage('scss', _scss2.default);
	_highlight2.default.registerLanguage('xml', _xml2.default);
	_highlight2.default.registerLanguage('javascript', _javascript2.default);
	_highlight2.default.registerLanguage('bash', _bash2.default);
	
	exports.default = {
	  props: {
	    lang: String,
	    height: {
	      type: [Number, String],
	      default: '450px'
	    }
	  },
	  data: function data() {
	    return {
	      showMessage: false
	    };
	  },
	  methods: {
	    enableCopy: function enableCopy() {
	      var _this = this;
	
	      var clipboard = new _clipboard2.default(this.$refs.copy.$el, {
	        target: function target() {
	          return _this.$refs.block;
	        }
	      });
	
	      clipboard.on('success', function (event) {
	        event.clearSelection();
	        _this.showMessage = true;
	
	        window.setTimeout(function () {
	          _this.showMessage = false;
	        }, 2000);
	      });
	    },
	    reindent: function reindent() {
	      var block = this.$refs.block;
	      var lines = block.textContent.split('\n');
	      var matches = void 0;
	
	      if (lines[0] === '') {
	        lines.shift();
	      }
	
	      var indentation = (matches = /^[\s\t]+/.exec(lines[0])) !== null ? matches[0] : null;
	
	      if (indentation) {
	        lines = lines.map(function (line) {
	          line = line.replace(indentation, '');
	
	          return line.replace(/\t/g, '  ');
	        });
	
	        block.textContent = lines.join('\n').trim();
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.reindent();
	    this.enableCopy();
	
	    if (this.exampleBoxParent) {
	      this.exampleBoxParent.codeBlocks.push({
	        lang: this.lang,
	        code: this.$refs.block.innerHTML
	      });
	    }
	
	    _highlight2.default.highlightBlock(this.$refs.block);
	  }
	};

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(326);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    cardTitle: String
	  },
	  data: function data() {
	    return {
	      codeBlocks: [],
	      codeString: ''
	    };
	  },
	  methods: {
	    editOnCodepen: function editOnCodepen() {
	      var _this = this;
	
	      var data = {
	        title: 'Vue Material - ' + this.cardTitle,
	        private: false,
	        head: '<meta name="viewport" content="width=device-width">',
	        html_pre_processor: 'none',
	        js_pre_processor: 'none',
	        js: this.$refs.initialJs.innerHTML,
	        css_pre_processor: 'scss',
	        css_starter: 'neither',
	        css_prefix_free: false,
	        css_external: ['http://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic', 'http://fonts.googleapis.com/icon?family=Material+Icons', 'https://cdn.rawgit.com/marcosmoura/vue-material/master/dist/vue-material.css'].join(';'),
	        js_external: ['https://cdnjs.cloudflare.com/ajax/libs/vue/2.1.3/vue.min.js', 'https://cdn.rawgit.com/marcosmoura/vue-material/master/dist/vue-material.js'].join(';')
	      };
	
	      this.codeBlocks.forEach(function (block) {
	        if (block.lang === 'xml') {
	          var initialHtml = _this.$refs.initialHtml.innerHTML;
	
	          data.html = initialHtml.replace('### TEMPLATE ###', block.code);
	        } else if (block.lang === 'javascript') {
	          data.js = data.js += block.code;
	        } else {
	          data.css = block.code;
	        }
	      });
	
	      this.codeString = (0, _stringify2.default)(data).replace(/"/g, '&quot;').replace(/'/g, '&apos;');
	
	      this.$nextTick(function () {
	        console.log(_this.$refs.initialJs);
	        _this.$refs.form.submit();
	      });
	    }
	  }
	};

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _auth = __webpack_require__(41);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _main = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      auth: {
	        isAdministrative: false
	      }
	    };
	  },
	
	  props: {
	    pageTitle: String
	  },
	  methods: {
	    redirect: function redirect(url, theme) {
	      _vue2.default.material.setCurrentTheme(theme);
	      _main.router.push({
	        name: url
	      });
	    },
	    toggleSidenav: function toggleSidenav() {
	      this.$root.toggleSidenav();
	    },
	    signout: function signout() {
	      _auth2.default.signout();
	    }
	  },
	  mounted: function mounted() {
	    document.title = this.pageTitle + ' - Valet Parking';
	    if (_auth2.default.user.profile === null) {
	      _main.router.push({
	        name: 'signin'
	      });
	    } else if (_auth2.default.user.profile.role.rlms_id === 20) {
	      this.auth.isAdministrative = true;
	    }
	  }
	};

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue2GoogleMaps = __webpack_require__(212);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: 'AIzaSyCJfGbecfuKpEMJiDHyzW234fVEjEjcUpU',
	    v: '3.25'
	  }
	});
	exports.default = {
	  data: function data() {
	    return {
	      center: { lat: -6.2256158, lng: 106.8101348 },
	      markers: [{
	        position: { lat: -6.2256158, lng: 106.8101348 }
	      }]
	    };
	  }
	};

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue2GoogleMaps = __webpack_require__(212);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _vue = __webpack_require__(23);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: 'AIzaSyCJfGbecfuKpEMJiDHyzW234fVEjEjcUpU',
	    v: '3.27'
	  }
	});
	exports.default = {
	  data: function data() {
	    return {
	      center: { lat: -6.2256158, lng: 106.8101348 },
	      markers: [{
	        position: { lat: -6.2256158, lng: 106.8101348 }
	      }]
	    };
	  }
	};

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(41);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      email: null,
	      password: null,
	      error: false
	    };
	  },
	
	  methods: {
	    signin: function signin(event) {
	      event.preventDefault();
	      _auth2.default.signin(this, this.email, this.password);
	    }
	  }
	};

/***/ }),

/***/ 378:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 379:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 381:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 389:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 393:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 81,
		"./af.js": 81,
		"./ar": 88,
		"./ar-dz": 82,
		"./ar-dz.js": 82,
		"./ar-kw": 83,
		"./ar-kw.js": 83,
		"./ar-ly": 84,
		"./ar-ly.js": 84,
		"./ar-ma": 85,
		"./ar-ma.js": 85,
		"./ar-sa": 86,
		"./ar-sa.js": 86,
		"./ar-tn": 87,
		"./ar-tn.js": 87,
		"./ar.js": 88,
		"./az": 89,
		"./az.js": 89,
		"./be": 90,
		"./be.js": 90,
		"./bg": 91,
		"./bg.js": 91,
		"./bm": 92,
		"./bm.js": 92,
		"./bn": 93,
		"./bn.js": 93,
		"./bo": 94,
		"./bo.js": 94,
		"./br": 95,
		"./br.js": 95,
		"./bs": 96,
		"./bs.js": 96,
		"./ca": 97,
		"./ca.js": 97,
		"./cs": 98,
		"./cs.js": 98,
		"./cv": 99,
		"./cv.js": 99,
		"./cy": 100,
		"./cy.js": 100,
		"./da": 101,
		"./da.js": 101,
		"./de": 104,
		"./de-at": 102,
		"./de-at.js": 102,
		"./de-ch": 103,
		"./de-ch.js": 103,
		"./de.js": 104,
		"./dv": 105,
		"./dv.js": 105,
		"./el": 106,
		"./el.js": 106,
		"./en-SG": 107,
		"./en-SG.js": 107,
		"./en-au": 108,
		"./en-au.js": 108,
		"./en-ca": 109,
		"./en-ca.js": 109,
		"./en-gb": 110,
		"./en-gb.js": 110,
		"./en-ie": 111,
		"./en-ie.js": 111,
		"./en-il": 112,
		"./en-il.js": 112,
		"./en-nz": 113,
		"./en-nz.js": 113,
		"./eo": 114,
		"./eo.js": 114,
		"./es": 117,
		"./es-do": 115,
		"./es-do.js": 115,
		"./es-us": 116,
		"./es-us.js": 116,
		"./es.js": 117,
		"./et": 118,
		"./et.js": 118,
		"./eu": 119,
		"./eu.js": 119,
		"./fa": 120,
		"./fa.js": 120,
		"./fi": 121,
		"./fi.js": 121,
		"./fo": 122,
		"./fo.js": 122,
		"./fr": 125,
		"./fr-ca": 123,
		"./fr-ca.js": 123,
		"./fr-ch": 124,
		"./fr-ch.js": 124,
		"./fr.js": 125,
		"./fy": 126,
		"./fy.js": 126,
		"./ga": 127,
		"./ga.js": 127,
		"./gd": 128,
		"./gd.js": 128,
		"./gl": 129,
		"./gl.js": 129,
		"./gom-latn": 130,
		"./gom-latn.js": 130,
		"./gu": 131,
		"./gu.js": 131,
		"./he": 132,
		"./he.js": 132,
		"./hi": 133,
		"./hi.js": 133,
		"./hr": 134,
		"./hr.js": 134,
		"./hu": 135,
		"./hu.js": 135,
		"./hy-am": 136,
		"./hy-am.js": 136,
		"./id": 137,
		"./id.js": 137,
		"./is": 138,
		"./is.js": 138,
		"./it": 140,
		"./it-ch": 139,
		"./it-ch.js": 139,
		"./it.js": 140,
		"./ja": 141,
		"./ja.js": 141,
		"./jv": 142,
		"./jv.js": 142,
		"./ka": 143,
		"./ka.js": 143,
		"./kk": 144,
		"./kk.js": 144,
		"./km": 145,
		"./km.js": 145,
		"./kn": 146,
		"./kn.js": 146,
		"./ko": 147,
		"./ko.js": 147,
		"./ku": 148,
		"./ku.js": 148,
		"./ky": 149,
		"./ky.js": 149,
		"./lb": 150,
		"./lb.js": 150,
		"./lo": 151,
		"./lo.js": 151,
		"./lt": 152,
		"./lt.js": 152,
		"./lv": 153,
		"./lv.js": 153,
		"./me": 154,
		"./me.js": 154,
		"./mi": 155,
		"./mi.js": 155,
		"./mk": 156,
		"./mk.js": 156,
		"./ml": 157,
		"./ml.js": 157,
		"./mn": 158,
		"./mn.js": 158,
		"./mr": 159,
		"./mr.js": 159,
		"./ms": 161,
		"./ms-my": 160,
		"./ms-my.js": 160,
		"./ms.js": 161,
		"./mt": 162,
		"./mt.js": 162,
		"./my": 163,
		"./my.js": 163,
		"./nb": 164,
		"./nb.js": 164,
		"./ne": 165,
		"./ne.js": 165,
		"./nl": 167,
		"./nl-be": 166,
		"./nl-be.js": 166,
		"./nl.js": 167,
		"./nn": 168,
		"./nn.js": 168,
		"./pa-in": 169,
		"./pa-in.js": 169,
		"./pl": 170,
		"./pl.js": 170,
		"./pt": 172,
		"./pt-br": 171,
		"./pt-br.js": 171,
		"./pt.js": 172,
		"./ro": 173,
		"./ro.js": 173,
		"./ru": 174,
		"./ru.js": 174,
		"./sd": 175,
		"./sd.js": 175,
		"./se": 176,
		"./se.js": 176,
		"./si": 177,
		"./si.js": 177,
		"./sk": 178,
		"./sk.js": 178,
		"./sl": 179,
		"./sl.js": 179,
		"./sq": 180,
		"./sq.js": 180,
		"./sr": 182,
		"./sr-cyrl": 181,
		"./sr-cyrl.js": 181,
		"./sr.js": 182,
		"./ss": 183,
		"./ss.js": 183,
		"./sv": 184,
		"./sv.js": 184,
		"./sw": 185,
		"./sw.js": 185,
		"./ta": 186,
		"./ta.js": 186,
		"./te": 187,
		"./te.js": 187,
		"./tet": 188,
		"./tet.js": 188,
		"./tg": 189,
		"./tg.js": 189,
		"./th": 190,
		"./th.js": 190,
		"./tl-ph": 191,
		"./tl-ph.js": 191,
		"./tlh": 192,
		"./tlh.js": 192,
		"./tr": 193,
		"./tr.js": 193,
		"./tzl": 194,
		"./tzl.js": 194,
		"./tzm": 196,
		"./tzm-latn": 195,
		"./tzm-latn.js": 195,
		"./tzm.js": 196,
		"./ug-cn": 197,
		"./ug-cn.js": 197,
		"./uk": 198,
		"./uk.js": 198,
		"./ur": 199,
		"./ur.js": 199,
		"./uz": 201,
		"./uz-latn": 200,
		"./uz-latn.js": 200,
		"./uz.js": 201,
		"./vi": 202,
		"./vi.js": 202,
		"./x-pseudo": 203,
		"./x-pseudo.js": 203,
		"./yo": 204,
		"./yo.js": 204,
		"./zh-cn": 205,
		"./zh-cn.js": 205,
		"./zh-hk": 206,
		"./zh-hk.js": 206,
		"./zh-tw": 207,
		"./zh-tw.js": 207
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 405;


/***/ }),

/***/ 408:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo-vue-material-default.fa8ffa7.png";

/***/ }),

/***/ 412:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(394)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(236),
	  /* template */
	  __webpack_require__(583),
	  /* scopeId */
	  "data-v-7c76f50c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(385)
	__webpack_require__(384)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(237),
	  /* template */
	  __webpack_require__(528),
	  /* scopeId */
	  "data-v-1da962d0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(380)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(516),
	  /* scopeId */
	  "data-v-06b637fa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 415:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(381)
	__webpack_require__(382)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(238),
	  /* template */
	  __webpack_require__(519),
	  /* scopeId */
	  "data-v-0bb73e8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(388)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(239),
	  /* template */
	  __webpack_require__(557),
	  /* scopeId */
	  "data-v-4823a9e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(389)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(559),
	  /* scopeId */
	  "data-v-4f3c9fa8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 418:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(383)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(524),
	  /* scopeId */
	  "data-v-126169c8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(240),
	  /* template */
	  __webpack_require__(531),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 420:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(241),
	  /* template */
	  __webpack_require__(536),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(390)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(242),
	  /* template */
	  __webpack_require__(560),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(320),
	  /* template */
	  __webpack_require__(535),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(321),
	  /* template */
	  __webpack_require__(578),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(323),
	  /* template */
	  __webpack_require__(508),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(392)
	
	var Component = __webpack_require__(2)(
	  /* script */
	  __webpack_require__(324),
	  /* template */
	  __webpack_require__(577),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "input",
	    class: _vm.className,
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 516:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "main-content component-docs"
	  }, [_c('div', {
	    staticClass: "usage-content"
	  }, [_c('section', {
	    staticClass: "component-description"
	  }, [_c('h2', {
	    staticClass: "md-headline"
	  }, [_vm._v("Description")]), _vm._v(" "), _vm._t("description")], 2), _vm._v(" "), (_vm.$slots.api) ? _c('section', {
	    staticClass: "api-documentation"
	  }, [_c('h2', {
	    staticClass: "md-headline"
	  }, [_vm._v("API Options")]), _vm._v(" "), _vm._t("api")], 2) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
	    staticClass: "example-content"
	  }, [_vm._t("example")], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 519:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "example-box"
	  }, [_c('md-card', {
	    staticClass: "example-box-card"
	  }, [_c('md-toolbar', {
	    staticClass: "md-dense",
	    attrs: {
	      "md-theme": "white"
	    }
	  }, [_c('h3', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.cardTitle))])]), _vm._v(" "), _c('md-card-area', [_c('md-tabs', {
	    staticClass: "md-transparent example-tabs",
	    attrs: {
	      "md-right": "",
	      "md-dynamic-height": false
	    }
	  }, [_c('md-tab', {
	    staticClass: "example-content",
	    attrs: {
	      "md-label": "Demo",
	      "md-active": ""
	    }
	  }, [_vm._t("demo")], 2), _vm._v(" "), _c('md-tab', {
	    staticClass: "code-content",
	    attrs: {
	      "md-label": "Code"
	    }
	  }, [_vm._t("code")], 2)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 524:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "main-content"
	  }, [_c('section', [_c('h2', {
	    staticClass: "md-headline"
	  }, [_vm._v("Hmmm. Too bad")]), _vm._v(" "), _c('p', [_vm._v("Are you searching for a new component? Or maybe you have an question? Get in touch!")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary md-raised",
	    attrs: {
	      "href": "mailto:marcosvmmoura@gmail.com?Subject=Vue%20Material%20-%20Question",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("E-mail")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary md-raised",
	    attrs: {
	      "href": "https://github.com/marcosmoura/vue-material/issues/new",
	      "target": "_blank",
	      "rel": "noopener"
	    }
	  }, [_vm._v("New Issue")])], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 528:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "code-block",
	    attrs: {
	      "data-lang": _vm.lang
	    }
	  }, [_c('div', {
	    staticClass: "code-block-wrapper",
	    style: ({
	      'max-height': _vm.height
	    })
	  }, [_c('pre', [_c('code', {
	    ref: "block",
	    class: _vm.lang
	  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('span', {
	    staticClass: "copied",
	    class: {
	      'active': _vm.showMessage
	    }
	  }, [_vm._v("Copied!")])]), _vm._v(" "), _c('md-button', {
	    ref: "copy",
	    staticClass: "md-icon-button md-dense"
	  }, [_c('md-icon', [_vm._v("content_copy")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-content', {
	    attrs: {
	      "page-title": "Landing Page"
	    }
	  }, [_c('gmap-map', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    },
	    attrs: {
	      "center": _vm.center,
	      "zoom": 17
	    }
	  }, _vm._l((_vm.markers), function(m) {
	    return _c('gmap-marker', {
	      attrs: {
	        "position": m.position,
	        "clickable": true,
	        "draggable": true
	      },
	      on: {
	        "click": function($event) {
	          _vm.center = m.position
	        }
	      }
	    })
	  }))], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 535:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('gmap-map', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    },
	    attrs: {
	      "center": _vm.center,
	      "zoom": 17
	    }
	  }, _vm._l((_vm.markers), function(m) {
	    return _c('gmap-marker', {
	      attrs: {
	        "position": m.position,
	        "clickable": true,
	        "draggable": true
	      },
	      on: {
	        "click": function($event) {
	          _vm.center = m.position
	        }
	      }
	    })
	  }))
	},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [(_vm.auth.user.authenticated) ? _c('md-sidenav', {
	    ref: "main-sidebar",
	    staticClass: "main-sidebar md-left md-fixed"
	  }, [_c('md-toolbar', {
	    staticClass: "vue-material-logo",
	    staticStyle: {
	      "border-bottom-style": "none"
	    },
	    attrs: {
	      "md-theme": "white"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/landing"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "border-radius": "20px",
	      "width": "130px",
	      "margin-top": "10px"
	    },
	    attrs: {
	      "src": _vm.logo,
	      "alt": "Vue"
	    }
	  }), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('md-list', [(_vm.auth.user.hasRole_keuangan === true) ? _c('div', [_c('md-list-item', {
	    staticClass: "pd_center",
	    attrs: {
	      "md-align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "has-ripple purple",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - KEUANGAN ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("import_contacts")]), _vm._v("   Reports")], 1), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/dailyheaders"
	    }
	  }, [_vm._v("Daily Headers")])], 1), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/dailydetails"
	    }
	  }, [_vm._v("Daily Details")])], 1), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/finefeedetails"
	    }
	  }, [_vm._v("Fine Fee Details")])], 1), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/parkfeedetails"
	    }
	  }, [_vm._v("Park Fee Details")])], 1), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/itemdetails"
	    }
	  }, [_vm._v("Items Reported")])], 1), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset"
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/reports/defectdetails"
	    }
	  }, [_vm._v("Defects Reported")])], 1)], 1)], 1)], 1)], 1) : (_vm.auth.user.hasRole_adminsystem === true) ? _c('div', [_c('md-list-item', {
	    staticClass: "pd_center",
	    attrs: {
	      "md-align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "has-ripple purple",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - ADMIN SYSTEM ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('span', [_c('md-icon', {
	    staticClass: "md-warn"
	  }, [_vm._v("local_library")]), _vm._v("   MASTERS ")], 1), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('div', {
	    staticStyle: {
	      "padding-left": "20px"
	    }
	  }, [_c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:company', 'MASTER - COMPANIES')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("domain")]), _vm._v("   Companies")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:car', 'MASTER - CARS')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("local_taxi")]), _vm._v("   Cars")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:color', 'MASTER - COLORS')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("invert_colors")]), _vm._v("   Colors")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:monitor', 'MASTER - MONITORS')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("timeline")]), _vm._v("   Monitor")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:status', 'MASTER - STATUS')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("notifications_paused")]), _vm._v("   Status")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:role', 'MASTER - ROLE')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("group")]), _vm._v("   Role")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:postal', 'MASTER - POSTAL CODE')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("local_post_office")]), _vm._v("   Postal Code")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:payment_categories', 'MASTER - PAY Category')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("monetization_on")]), _vm._v("   Payment Categories")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:defect_master', 'MASTER - Defects')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("healing")]), _vm._v("   Defects")], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('adsys:masters:menu', 'MASTER - MENUS')
	      }
	    }
	  }, [_c('span', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("menu")]), _vm._v("   MENU")], 1)])], 1)])], 1)], 1)], 1) : (_vm.auth.user.hasRole_administrative === true) ? _c('div', [_c('md-list-item', {
	    staticClass: "pd_center",
	    attrs: {
	      "md-align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "has-ripple purple",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" MENU - RUNNER / CASHIER ")])], 1)]), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("directions_car")]), _vm._v(" "), _c('span', [_vm._v(" Status ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:status_checkin', 'Status Check In')
	      }
	    }
	  }, [_c('span', [_vm._v(" Check In ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:status_checkout', 'Status Check Out')
	      }
	    }
	  }, [_c('span', [_vm._v(" Check Out ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:status_all', 'Status All')
	      }
	    }
	  }, [_c('span', [_vm._v(" All Status ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:history', 'Histories')
	      }
	    }
	  }, [_c('span', [_vm._v(" Log Histories ")])])], 1)], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("trending_up")]), _vm._v(" "), _c('span', [_vm._v(" Reports ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:status_find', 'Find Data')
	      }
	    }
	  }, [_c('span', [_vm._v(" Find Data ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('administrative:reports_main', 'Main Reports')
	      }
	    }
	  }, [_c('span', [_vm._v(" Main Reports ")])])], 1)], 1)], 1)], 1) : (_vm.auth.user.profile.role.rlms_id === 40) ? _c('div', [_c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('keyguard:request', 'Requests')
	      }
	    }
	  }, [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("notifications")]), _vm._v(" "), _c('span', [_vm._v(" Requests ")])], 1), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('keyguard:status', 'Status')
	      }
	    }
	  }, [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("vpn_key")]), _vm._v(" "), _c('span', [_vm._v(" Status ")])], 1), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('keyguard:history', 'Histories')
	      }
	    }
	  }, [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("history")]), _vm._v(" "), _c('span', [_vm._v(" Histories ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("trending_up")]), _vm._v(" "), _c('span', [_vm._v(" Reports ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('keyguard:reports', 'Reports')
	      }
	    }
	  }, [_c('span', [_vm._v(" Main Reports ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('keyguard:reports', 'Reports')
	      }
	    }
	  }, [_c('span', [_vm._v(" Unclosed Reports ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('md-list-item', {
	    staticClass: "pd_center",
	    attrs: {
	      "md-align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "has-ripple purple",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('md-ink-ripple'), _vm._v(" "), _c('span', [_vm._v(" USER PREFERENCE ")])], 1)]), _vm._v(" "), _c('md-list-item', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('maps', 'Maps')
	      }
	    }
	  }, [_c('md-icon', {
	    staticClass: "md-primary"
	  }, [_vm._v("my_location")]), _vm._v(" "), _c('span', [_vm._v(" Maps ")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-icon', {
	    staticClass: "md-warn"
	  }, [_vm._v("account_circle")]), _vm._v(" "), _c('span', [_vm._v(" Account ")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('preference:site', 'Change Site')
	      }
	    }
	  }, [_c('span', [_vm._v(" Change Site ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('preference:profile', 'Change Profile')
	      }
	    }
	  }, [_c('span', [_vm._v(" Change Profile ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('preference:password', 'Change Password')
	      }
	    }
	  }, [_c('span', [_vm._v(" Change Password ")])]), _vm._v(" "), _c('md-list-item', {
	    staticClass: "md-inset",
	    nativeOn: {
	      "click": function($event) {
	        _vm.signout()
	      }
	    }
	  }, [_vm._v("\n                Logout\n              ")])], 1)], 1)], 1)], 1)])], 1) : (!_vm.auth.user.authenticated) ? _c('md-sidenav', {
	    ref: "main-sidebar",
	    staticClass: "main-sidebar md-left md-fixed"
	  }, [_c('md-toolbar', {
	    staticClass: "vue-material-logo",
	    staticStyle: {
	      "border": "0px",
	      "top": "50%",
	      "position": "relative",
	      "transform": "translateY(-50%)"
	    },
	    attrs: {
	      "md-theme": "white"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "exact": "",
	      "to": "/"
	    }
	  }, [_c('md-card-media', {
	    attrs: {
	      "md-with-hover": ""
	    }
	  }, [_c('md-ink-ripple'), _vm._v(" "), _c('img', {
	    staticClass: "md-raised",
	    staticStyle: {
	      "border-radius": "40px"
	    },
	    attrs: {
	      "src": _vm.logo,
	      "alt": "Vue"
	    }
	  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.auth.user.authenticated) ? _c('div', [_c('md-whiteframe', {
	    staticClass: "main-header",
	    attrs: {
	      "md-tag": "md-toolbar",
	      "md-elevation": "1"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-icon-button nav-trigger",
	    nativeOn: {
	      "click": function($event) {
	        _vm.toggleSidenav($event)
	      }
	    }
	  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("     " + _vm._s(_vm.pageTitle))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button",
	    attrs: {
	      "rel": "noopener"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.signout()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("exit_to_app")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "md-router",
	      "appear": ""
	    }
	  }, [_c('router-view')], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-content"
	  }, [_c('md-whiteframe', {
	    staticClass: "main-header",
	    attrs: {
	      "md-tag": "md-toolbar",
	      "md-elevation": "1"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-icon-button nav-trigger",
	    on: {
	      "click": _vm.toggleSidenav
	    }
	  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button",
	    attrs: {
	      "rel": "noopener"
	    },
	    on: {
	      "click": function($event) {
	        _vm.signout()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("exit_to_app")])], 1)], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.auth.isAdministrative) ? _c('md-bottom-bar', {
	    attrs: {
	      "md-shift": ""
	    }
	  }, [_c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "airport_shuttle"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('masters:color', 'blue')
	      }
	    }
	  }, [_vm._v(" Entry ")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "notifications"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('masters:flow', 'teal')
	      }
	    }
	  }, [_vm._v(" Request ")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "local_car_wash"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('masters:color', 'brown')
	      }
	    }
	  }, [_vm._v(" Status ")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "history"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('masters:color', 'indigo')
	      }
	    }
	  }, [_vm._v(" Histories ")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "place",
	      "md-active": ""
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.redirect('maps', 'blue-grey')
	      }
	    }
	  }, [_vm._v(" Maps ")])], 1) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('page-content', {
	    attrs: {
	      "page-title": "Dashboard Parking"
	    }
	  }, [_c('md-list', [_c('md-list-item', [_c('md-avatar', {
	    staticClass: "md-avatar-icon md-primary"
	  }, [_c('md-icon', [_vm._v("insert_drive_file")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-list-text-container"
	  }, [_c('span', [_vm._v("Vacation Itinerary")]), _vm._v(" "), _c('p', [_vm._v("Jan 20, 2014")])]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button md-list-action"
	  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
	    staticClass: "md-avatar-icon md-primary",
	    attrs: {
	      "md-theme": "orange"
	    }
	  }, [_c('md-icon', [_vm._v("collections")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-list-text-container"
	  }, [_c('span', [_vm._v("Kitchen Remodel")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button md-list-action"
	  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
	    staticClass: "md-avatar-icon md-primary",
	    attrs: {
	      "md-theme": "green"
	    }
	  }, [_c('md-icon', [_vm._v("view_list")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-list-text-container"
	  }, [_c('span', [_vm._v("Grocery Shop")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button md-list-action"
	  }, [_c('md-icon', [_vm._v("info")])], 1)], 1), _vm._v(" "), _c('md-list-item', [_c('md-avatar', {
	    staticClass: "md-avatar-icon md-primary",
	    attrs: {
	      "md-theme": "orange"
	    }
	  }, [_c('md-icon', [_vm._v("collections")])], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-list-text-container"
	  }, [_c('span', [_vm._v("Weekend Pictures")]), _vm._v(" "), _c('p', [_vm._v("Jan 10, 2014")])]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button md-list-action"
	  }, [_c('md-icon', [_vm._v("info")])], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "signin-container"
	  }, [_c('span', {
	    staticClass: "md-subheading",
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Welcome, Please Login ... ")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": _vm.signin
	    }
	  }, [_c('md-input-container', [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("  E-mail")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "text",
	      "id": "email",
	      "required": "",
	      "autofocus": ""
	    },
	    model: {
	      value: (_vm.email),
	      callback: function($$v) {
	        _vm.email = $$v
	      },
	      expression: "email"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', {
	    attrs: {
	      "md-has-password": ""
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("  Password")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password",
	      "id": "password",
	      "required": ""
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.error) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_c('p', [_vm._v("There was an error, unable to sign in with those credentials.")])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
	    attrs: {
	      "md-column": "",
	      "md-gutter": ""
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary",
	    staticStyle: {
	      "color": "white"
	    },
	    attrs: {
	      "type": "submit"
	    }
	  }, [_c('md-icon', [_vm._v("input")]), _vm._v("   Log In")], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('md-layout', {
	    attrs: {
	      "md-gutter": "",
	      "md-flex": "33",
	      "md-flex-offset": "33"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-primary"
	  }, [_c('md-icon', [_vm._v("supervisor_account")]), _vm._v("   Register")], 1), _vm._v(" "), _c('md-button', {
	    staticClass: "md-default md-mini"
	  }, [_c('md-icon', [_vm._v("info")]), _vm._v("   forgot password")], 1)], 1)], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 577:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-street-view-pano-container"
	  }, [_c('div', {
	    ref: "vue-street-view-pano",
	    staticClass: "vue-street-view-pano"
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 578:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "flyaway"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-map-container"
	  }, [_c('div', {
	    ref: "vue-map",
	    staticClass: "vue-map"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-map-hidden"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 583:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "api-table"
	  }, [_c('h3', {
	    staticClass: "md-title"
	  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.$slots.default) ? _vm._t("default") : _vm._e(), _vm._v(" "), (_vm.slotNames.length > 1 || !_vm.$slots.default) ? _c('md-tabs', {
	    staticClass: "md-transparent",
	    attrs: {
	      "md-dynamic-height": false
	    }
	  }, [(_vm.$slots.properties) ? _c('md-tab', {
	    staticClass: "api-tab",
	    attrs: {
	      "md-label": "Properties"
	    }
	  }, [_vm._t("properties")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.classes) ? _c('md-tab', {
	    staticClass: "api-tab",
	    attrs: {
	      "md-label": "Classes"
	    }
	  }, [_vm._t("classes")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.events) ? _c('md-tab', {
	    staticClass: "api-tab",
	    attrs: {
	      "md-label": "Events"
	    }
	  }, [_vm._t("events")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.methods) ? _c('md-tab', {
	    staticClass: "api-tab",
	    attrs: {
	      "md-label": "Methods"
	    }
	  }, [_vm._t("methods")], 2) : _vm._e()], 1) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.7b76ebaced1158d12894.js